// services/fontteService/orders.ts - services/fontteService.ts split (sub-module orders)


import type {FontteResponse} from './types.js';
import { sendWhatsAppMessage } from './base.js';


export async function sendOrderConfirmation(
    phoneNumber: string,
    orderData: {
        orderId: string; customerName: string; productName: string; totalPrice: number;
        deliveryEstimate?: string; shippingAddress?: string; province?: string;
        city?: string; district?: string; village?: string; postalCode?: string;
    },
    options?: { brandId?: string; csId?: string; device?: string; customApiKey?: string; template?: string }
): Promise<FontteResponse> {
    const applyTemplate = (template: string) => {
        const totalPriceFormatted = `Rp ${orderData.totalPrice.toLocaleString('id-ID')}`;
        return template
            .replace(/\[CUSTOMER_NAME\]/g, orderData.customerName)
            .replace(/\[ORDER_ID\]/g, orderData.orderId)
            .replace(/\[PRODUCT_NAME\]/g, orderData.productName)
            .replace(/\[TOTAL_PRICE\]/g, totalPriceFormatted)
            .replace(/\[DELIVERY_ESTIMATE\]/g, orderData.deliveryEstimate || 'Segera dikirim')
            .replace(/\[ADDRESS_FULL\]/g, orderData.shippingAddress || 'Alamat belum diisi')
            .replace(/\[PROVINCE\]/g, orderData.province || '-')
            .replace(/\[CITY\]/g, orderData.city || '-')
            .replace(/\[DISTRICT\]/g, orderData.district || '-')
            .replace(/\[VILLAGE\]/g, orderData.village || '-')
            .replace(/\[POSTAL_CODE\]/g, orderData.postalCode || '-');
    };

    const defaultMessage = `
Halo ${orderData.customerName}!

Terima kasih udah order ya 🎉 Pesanan kakak langsung diproses tim kita.

📋 *Ringkasan Pesanan*
- Kode: ${orderData.orderId}
- Produk: ${orderData.productName}
- Total: Rp ${orderData.totalPrice.toLocaleString('id-ID')}
${orderData.deliveryEstimate ? `- Estimasi: ${orderData.deliveryEstimate}` : ''}

🏠 *Dikirim ke:*
${orderData.shippingAddress ? `${orderData.shippingAddress}, ${orderData.village || '-'}, ${orderData.district || '-'}, ${orderData.city || '-'}, ${orderData.province || '-'} ${orderData.postalCode || ''}` : 'Alamat: (belum diisi)'}

*Proses selanjutnya:*
1️⃣ Packing & quality check
2️⃣ Pickup kurir
3️⃣ Resi + link tracking dikirim ke WA ini

Ada yang mau ditanyain? Balas aja ya, CS kita siap bantu 🙌
`.trim();

    const message = options?.template ? applyTemplate(options.template) : defaultMessage;
    return sendWhatsAppMessage(phoneNumber, message, '62', options?.device, options?.customApiKey);
}
